var _rect, _path, _path2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropose6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 34,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.898 30.0047C56.9787 22.1866 49.1308 17.3298 40.4143 17.3298C27.7761 17.3298 17.4941 27.6118 17.4941 40.25C17.4941 52.8881 27.7761 63.1701 40.4143 63.1701C49.1308 63.1701 56.9787 58.3133 60.898 50.4953C61.1606 49.9715 61.2127 49.367 61.0434 48.806C60.8742 48.245 60.4966 47.7702 59.9881 47.479L47.3293 40.25L59.9858 33.0233C61.0424 32.4182 61.4435 31.0934 60.898 30.0047ZM41.5695 38.2605C41.2183 38.4606 40.9264 38.75 40.7233 39.0994C40.5202 39.4489 40.4132 39.8458 40.4132 40.25C40.4132 40.6541 40.5202 41.0511 40.7233 41.4005C40.9264 41.7499 41.2183 42.0394 41.5695 42.2394L55.7181 50.3188C54.0587 52.8634 51.7893 54.9528 49.1165 56.3967C46.4436 57.8406 43.4522 58.5932 40.4143 58.5861C30.3042 58.5861 22.0782 50.36 22.0782 40.25C22.0782 30.1399 30.3042 21.9139 40.4143 21.9139C43.4519 21.9067 46.4432 22.6591 49.116 24.1025C51.7887 25.546 54.0582 27.6348 55.7181 30.1789L41.5695 38.2605Z",
    fill: "url(#paint0_linear_3061_17407)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2681 33.3739C41.1669 33.3739 42.7061 31.8347 42.7061 29.9359C42.7061 28.0371 41.1669 26.4979 39.2681 26.4979C37.3693 26.4979 35.8301 28.0371 35.8301 29.9359C35.8301 31.8347 37.3693 33.3739 39.2681 33.3739Z",
    fill: "url(#paint1_linear_3061_17407)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 8,
    r: 8,
    fill: "#D50101"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3061_17407",
    x1: 39.3177,
    y1: 17.5,
    x2: 39.3177,
    y2: 63.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3061_17407",
    x1: 39.2681,
    y1: 16.9998,
    x2: 39.2681,
    y2: 63.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59131"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropose6);
export default __webpack_public_path__ + "static/media/propose6.c331295d5d5edc84817bcabec60a137e.svg";
export { ForwardRef as ReactComponent };